import { apiService } from "../../../../../components/api/apiService";



export const agentService = {
  /**
   * Fetch all agent groups.
   * @returns Promise resolving to an array of agent groups.
   */
  getAgentGroups: () => {
    return apiService.get('/api/Agent/groups', {}, 'backend');
  },

  /**
   * Fetch all agents.
   * @returns Promise resolving to an array of agents.
   */
  getAgentList: () => {
    return apiService.get('/api/Agent/list', {}, 'backend');
  },
  renameAgent: (payload: { tenantId: string; agentId: string; newTitle: string }) =>
    apiService.post('/api/agent/rename', payload, 'backend'),
  createAgentGroup: async (group: {
    tenantId: string;
    name: string;
    description: string;
    iconUrl: string;
    createdBy: string;
  }) => {
    const response = await apiService.post('/api/agent/groups/create', group, 'backend');
    return response.data;
  },
  deleteAgentGroup: async (groupId: string) => {
    await apiService.post(`/api/agent/groups/${groupId}`, {}, 'backend');
  },
  createAgent: async (payload: any) => {
    const res = await apiService.post('/api/agent/create', payload, 'backend');
    return res;
  },
  deleteAgent: async (agentId: string) => {
    return await apiService.post(`/api/Agent/DeleteAgent?agentid=${agentId}`, {}, 'backend');
  },
  getAgentById: async (agentId: string) => {
    return await apiService.get(`/api/Agent/${agentId}`, {}, 'backend');
  },
  updateAgent: async (agentId: string, payload: any) => {
    return await apiService.post(`/api/agent/update/${agentId}`, payload, 'backend');
  },
  updateConfiguration: async (payload: any) => {
    return await apiService.post('/api/agent/update-configuration', payload, 'backend');
  },
};
